import { Search, LoaderCircle } from "lucide-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  formatDateFullYear,
  to2Decimal,
} from "../common/caseFormat";
import exportCSV from "../common/exportCSV";
import { ActionButton } from "../common/Buttons";
import { SearchBox } from "../common/SearchBox";

const InvoiceRegisterSubTable = ({ isLoading, subTableData = [] }) => {
  const isGray = false;
  const [search, setSearch] = useState("");

  let filteredSubTableData = [...subTableData];

  if (search.trim()) {
    const searchfilter = search.trim();
    filteredSubTableData = filteredSubTableData.filter(
      (item) =>
        item.prodcode?.toString().includes(searchfilter) ||
        item.prodname?.toLowerCase()?.includes(searchfilter.toLowerCase())
    );
  }

  const totalNetAmount = filteredSubTableData
    .reduce((sum, item) => {
      return sum + (parseFloat(item.netam) || 0);
    }, 0)
    .toFixed(2);

  const columns = [
    { key: "prodcode", label: "Code" },
    { key: "prodname", label: "Name" },
    { key: "aqty", label: "Qty" },
    { key: "rate", label: "Rate" },
    { key: "netam", label: "Amount", format: to2Decimal },
  ];

  // csv export function
  const handleCsvExport = () => {
    if (!filteredSubTableData.length) return;
    exportCSV(filteredSubTableData, columns, "invoice-register-sub-table");
  };

  return (
    <div
      style={{ maxHeight: "100%" }}
      className={`w-full h-[29rem] flex flex-col rounded-[15px] overflow-hidden`}
    >
      {/* Search + Table Header */}
      <div className={`w-full shrink-0 bg-sixth text-white`}>
        <div className="flex justify-between items-center px-4 py-4">
          <div className="flex items-center gap-2 px-2 py-1 md:w-80">
            <SearchBox
              placeholder="Search orders..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              disabled={isLoading || subTableData.length === 0}
            />
          </div>

          {filteredSubTableData?.length > 0 && (
            <ActionButton
              text={"Export CSV"}
              onClick={handleCsvExport}
              customStyle="squircle-a-18"
            />
          )}
        </div>

        <div className={`flex font-semibold px-3 py-2 gap-6 pr-7`}>
          <p className="w-[20%]">Code</p>
          <p className="w-[40%]">Name</p>
          <p className="w-[10%] text-right pr-4">Qty</p>
          <p className="w-[10%]">Rate</p>
          <p className="w-[20%] text-right pr-4">Amount</p>
        </div>
      </div>

      {/* Rows */}
      <div className="flex-1 overflow-y-scroll bg-white">
        {isLoading ? (
          <p className="w-full h-36 flex justify-center items-center">
            <LoaderCircle className="animate-spin" />
          </p>
        ) : filteredSubTableData.length > 0 ? (
          filteredSubTableData.map((item) => (
            <div
              key={item.prodcode}
              className={`flex px-3 gap-6 py-3 font-semibold text-sm border-b border-b-[var(--table-row-border)]`}
            >
              <p className="w-[20%]">{item.prodcode}</p>
              <p className="w-[40%]">{item.prodname}</p>
              <p className="w-[10%] text-right pr-4">{item.qty}</p>
              <p className="w-[10%]">{item.rate}</p>
              <p className="w-[20%] text-right pr-4">
                ₹ {to2Decimal(item.netam)}
              </p>
            </div>
          ))
        ) : (
          <p className="w-full h-36 flex justify-center items-center">
            No record found...
          </p>
        )}
      </div>

      {/* Footer */}
      {!isLoading && (
        <div
          className={`flex shrink-0 font-semibold px-3 py-2 gap-6 bg-sixth text-white`}
        >
          <p className="w-[80%]">
            Total records: {filteredSubTableData.length}
          </p>
          <p className="w-[20%] text-right pr-8">₹ {totalNetAmount}</p>
        </div>
      )}
    </div>
  );
};

export default InvoiceRegisterSubTable;
